import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0b8a5764&scoped=true&lang=pug"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"
import style0 from "./Edit.vue?vue&type=style&index=0&id=0b8a5764&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=0b8a5764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a5764",
  null
  
)

export default component.exports